import DatahubService from './DatahubService';

export const buildInteractionEventData = (eventData) => {
  return DatahubService.analyticsEventBuilder?.(eventData);
};
